import React, { Fragment, useState, useEffect } from 'react';
import { Col, Button } from "reactstrap";
import { SelectForm } from "../../Basicos/index";
import { axiosApi } from '../../Basicos/axiosInstances';

const FiltrosProfessor = ({ novoOnClick, dados, setDadosFiltrados, valoresFiltro, setValoresFiltro }) => {
    const [formacoesOptions, setFormacoesOptions] = useState([]);

    const coordenadorOptions = [
        { value: 'Sim', label: 'Sim' },
        { value: 'Não', label: 'Não' }
    ];

    const convidadoOptions = [
        { value: 'Sim', label: 'Sim' },
        { value: 'Não', label: 'Não' }
    ];

    const ativoOptions = [
        { value: 'Ativo', label: 'Ativo' },
        { value: 'Inativo', label: 'Inativo' }
    ];

    const style = {
        colFormacao: { xs: 12, md: 2, sm: 2, lg: 2, xl: 2 },
        colOutros: { xs: 6, md: 2, sm: 2, lg: 2, xl: 2 }
    };

    useEffect(() => {
        const getFormacoes = async () => {
            try {
                const { data } = await axiosApi.get('/auxiliares/formacoes');
                if (data && data.dados) {
                    setFormacoesOptions(data.dados.map(element => ({ label: element.nome, value: element.id })));
                }
            } catch (error) {
                console.error(error);
            }
        };
        getFormacoes();
    }, []);

    const onChangeSelect = (nome, valor) => {
        let novosValores = { ...valoresFiltro, [nome]: valor };
        setValoresFiltro(novosValores);

        let dadosFiltrados = dados;

        if (novosValores.tipo_formacao_id !== undefined) {
            dadosFiltrados = dadosFiltrados.filter(d => d.tipo_formacao_id === novosValores.tipo_formacao_id);
        }
        if (novosValores.coordenador_ativo !== undefined) {
            dadosFiltrados = dadosFiltrados.filter(d => {
                const valorCoordenador = d.coordenador_ativo;
                const filtroCoordenador = novosValores.coordenador_ativo;
                if (filtroCoordenador === 'Sim') {
                    return valorCoordenador === 'Sim' || valorCoordenador === true || valorCoordenador === 1 || valorCoordenador === '1';
                } else if (filtroCoordenador === 'Não') {
                    return valorCoordenador === 'Não' || valorCoordenador === false || valorCoordenador === 0 || valorCoordenador === '0' || valorCoordenador === null || valorCoordenador === undefined;
                }
                return false;
            });
        }
        if (novosValores.convidado !== undefined) {
            dadosFiltrados = dadosFiltrados.filter(d => {
                const valorConvidado = d.convidado;
                const filtroConvidado = novosValores.convidado;
                if (filtroConvidado === 'Sim') {
                    return valorConvidado === 'Sim' || valorConvidado === true || valorConvidado === 1 || valorConvidado === '1';
                } else if (filtroConvidado === 'Não') {
                    return valorConvidado === 'Não' || valorConvidado === false || valorConvidado === 0 || valorConvidado === '0' || valorConvidado === null || valorConvidado === undefined;
                }
                return false;
            });
        }
        if (novosValores.ativo !== undefined) {
            dadosFiltrados = dadosFiltrados.filter(d => {
                const valorAtivo = d.ativo;
                const filtroAtivo = novosValores.ativo;
                if (filtroAtivo === 'Ativo') {
                    return valorAtivo === 'Ativo' || valorAtivo === true || valorAtivo === 1 || valorAtivo === '1';
                } else if (filtroAtivo === 'Inativo') {
                    return valorAtivo === 'Inativo' || valorAtivo === false || valorAtivo === 0 || valorAtivo === '0' || valorAtivo === null || valorAtivo === undefined;
                }
                return false;
            });
        }

        setDadosFiltrados(dadosFiltrados);
    };

    return (
        <Fragment>
            <SelectForm
                label="Formação"
                name="tipo_formacao_id"
                placeholder="Formação"
                options={formacoesOptions}
                onChange={onChangeSelect}
                value={formacoesOptions && formacoesOptions.find(option => (option.value === valoresFiltro.tipo_formacao_id)) || ''}
                style={{ col: style.colFormacao }}
                menuPortalTarget={document.body}
            />
            <SelectForm
                label="Coordenador"
                name="coordenador_ativo"
                placeholder="Coordenador"
                options={coordenadorOptions}
                value={coordenadorOptions && coordenadorOptions.find(option => (option.value === valoresFiltro.coordenador_ativo)) || ''}
                onChange={onChangeSelect}
                style={{ col: style.colOutros }}
                menuPortalTarget={document.body}
            />
            <SelectForm
                label="Convidado"
                name="convidado"
                placeholder="Convidado"
                options={convidadoOptions}
                value={convidadoOptions && convidadoOptions.find(option => (option.value === valoresFiltro.convidado)) || ''}
                onChange={onChangeSelect}
                style={{ col: style.colOutros }}
                menuPortalTarget={document.body}
            />
            <SelectForm
                label="Ativo"
                name="ativo"
                placeholder="Ativo"
                options={ativoOptions}
                value={ativoOptions && ativoOptions.find(option => (option.value === valoresFiltro.ativo)) || ''}
                onChange={onChangeSelect}
                style={{ col: style.colOutros }}
                menuPortalTarget={document.body}
            />
            <Col xs={12} sm={12} md={2} lg={2} xl={2} className="form-col">
                <div className="form-group">
                    <label className="label-conteudoInferior label">
                        Pesquisar:
                    </label>
                    <div id="pesquisar-wrap"></div>
                </div>
            </Col>
            <Col className="btn-limpar-filtro" md={1} sm={1} lg={1} xl={1}>
                <Button className="mx-3 py-2"
                    onClick={() => {
                        setValoresFiltro({
                            tipo_formacao_id: undefined,
                            coordenador_ativo: undefined,
                            convidado: undefined,
                            ativo: undefined,
                            resetToken: Date.now()
                        });
                        setDadosFiltrados(dados);
                    }}>Limpar</Button>
            </Col>
            <Col className="btn-limpar-filtro" md={1} sm={1} lg={1} xl={1}>
                <Button className="mx-3 py-2" onClick={novoOnClick}>Novo</Button>
            </Col>
        </Fragment>
    );
};

export default FiltrosProfessor;
